export default {"src":"/_next/static/media/no-result.5bc6c9c1.svg","height":1027,"width":1485,"blurWidth":0,"blurHeight":0};